import _sfc_main from "./FlowOverlay.vue2.js";
import _export_sfc from "../_virtual/_plugin-vue_export-helper.js";
const FlowOverlay = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-2b67956b"]]);
export {
  FlowOverlay as default
};
//# sourceMappingURL=FlowOverlay.vue.js.map
